import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../Components/TopMenu/TopMenu';
import View from "../../../assets/images/view.png";
import Rapdf from "../../../assets/images/pdf.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Dropdown, Badge, Button, Form, FormGroup } from 'react-bootstrap';
import { faPlus, faXmark, faUpload, faPaperclip, faDownload, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
import { Tabs, Tab } from 'react-bootstrap';
import Edit from "../../../assets/images/pen.png";
import pen from "../../../assets/images/pen.png";
import Info_edit from "../../../assets/images/info.png";
import Export from "../../../assets/images/export.svg";
import { toast } from 'react-toastify';
import { withRFSToken } from '../../../Services/axios';
import EmailGreen from "../../../assets/images/recover_email.png";
import EmailRed from "../../../assets/images/pending_email.png";
import greencheck from "../../../assets/images/green_check.png";
import greycheck from "../../../assets/images/grey_check.png";
import orangecheck from "../../../assets/images/orange_check.png";
import ConfModal from '../../../Components/common/ConfModal';
import { useHistory } from 'react-router-dom';
import { jqxCookieCall } from '../../../Components/common/CommonFunctions';

const Invoice = () => {

    const isMounted = useRef(false);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [filterApplied, setFilterApplied] = useState(false);
    const [activeTab, setActiveTab] = useState('Active');
    const gridRefs = {
        Active: useRef(null),
        Consolidate: useRef(null),
        Archived: useRef(null),
    };
    const [gridData, setGridData] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [emailData, setEmailData] = useState({ email: '' });
    const [emailMeta, setEmailMeta] = useState({});
    const [isEmailSaving, setIsEmailSaving] = useState(false);

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
    };

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall();
            let tabType = '';
            tabType = activeTab === 'Active' ? 'A' : activeTab === 'Consolidate' ? 'C' : 'R';
            let datafields = [];
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'is_deleted', type: 'string' },
                    { name: 'shipment_record_id', type: 'string' },
                    { name: 'invoice_id', type: 'string' },
                    { name: 'shipment_details', type: 'string' },
                    { name: 'items', type: 'string' },
                    { name: 'created_at', type: 'string' },
                    { name: 'total', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'condition', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'scm', type: 'string' },
                    { name: 'scm_date', type: 'date' },
                    { name: 'asset_type', type: 'string' },
                    { name: 'handler_name', type: 'string' },
                    { name: 'repair_name', type: 'string' },
                    { name: 'record_id', type: 'string' },
                    { name: 'invoice_id', type: 'string' },
                    { name: 'year_invoice', type: 'string' },
                    { name: 'period', type: 'string' },
                    { name: 'expiry_date', type: 'string' },
                    { name: 'account_number', type: 'string' },
                    { name: 'vat_code', type: 'string' },
                    { name: 'vat', type: 'string' },
                    { name: 'subtotal', type: 'string' },
                    { name: 'vat_amount', type: 'string' },
                    { name: 'download_status', type: 'string' },
                    { name: 'currency', type: 'string' },
                    { name: 'master_airwaybill', type: 'string' },
                    { name: 'download_date', type: 'string' },
                    { name: 'customer_id', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'customer_email', type: 'string' },
                    { name: 'customer_name', type: 'string' },
                    { name: 'send_date', type: 'string' },
                    { name: 'consolidated_id', type: 'string' },


                    { name: 'total_invoices', type: 'string' },
                    { name: 'colour', type: 'string' },
                    { name: 'total_amount', type: 'string' },
                    { name: 'send_status', type: 'string' },
                    { name: 'invoice_pdf', type: 'string' },
                    { name: 'organization', type: 'string' },
                    { name: 'invoices', type: 'string' },
                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}invoice/list?tab_name=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            let columns = []
            if (activeTab == 'Consolidate') {
                columns = [
                    { text: 'Customer', filtertype: 'input', datafield: 'customer_name', width: '10%', cellclassname: '', },
                    {
                        text: 'Customer Email', filtertype: 'input', datafield: 'customer_email', width: '14%', cellclassname: '',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                            let emailIcon = '';
                            let value1 = rowdata?.customer_email
                            if (!rowdata?.customer_email) {
                                emailIcon = '<img src="' + EmailRed + '" class="row_email row_email_red" />';
                            } else {
                                emailIcon = '<img src="' + EmailGreen + '" class="row_email row_email_green" />';
                            }
                            return value1 ? '<div class="jqx-grid-cell-left-align" style="margin-top: 10px;">' + emailIcon + ' ' + value1 + '</div>' : '';
                        }
                    },
                    { text: 'Year', filtertype: 'input', datafield: 'year_invoice', width: '8%', cellclassname: '', },
                    { text: 'Period', filtertype: 'input', datafield: 'period', width: '10%', cellclassname: '', },
                    { text: 'Total Amount', filtertype: 'input', datafield: 'total_amount', width: '10%', cellclassname: '', },
                    { text: 'Total Invoices', filtertype: 'input', datafield: 'total_invoices', width: '6%', cellclassname: '', },
                    {
                        text: "Mail Send", datafield: "colour", filtertype: "checkedlist", width: "5%", cellclassname: '',
                        filteritems: [
                            { label: "Yes", value: "Yes" },
                            { label: 'No', value: "No" },
                        ],
                        cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                            const rowId = rowData?.id || rowData?.bounddata?.id || "";
                            const iconMap = { green: greencheck, orange: orangecheck, gray: greycheck };
                            const icon = iconMap[cellValue];
                            if (!icon) return "";
                            return `
                                <div
                                    style="margin-top:13px;margin-left:10px; cursor:pointer;"
                                    class="mail-send-cell"
                                    data-row-id="${rowId}"
                                >
                                    <img src="${icon}" alt="${cellValue}" style="width:16px; height:16px;" />
                                </div>
                            `;
                        }
                    },
                    {
                        text: 'Send Date',filtertype: 'range', filtermode: 'range', datafield: 'send_date', width: '6%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split(' ')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    {
                        text: 'Invoice Pdf', datafield: 'invoice_pdf', width: '6%', cellclassname: '', filterable: false,
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            defaultHtml = "<div style='text-align: center;line-height: 38px;'><a class='pdf_click_action' style='cursor: pointer;'>  <img style='width: 25px;' src='" + Rapdf + "'/> </a></div>";
                            return (
                                defaultHtml
                            );
                        },

                    },
                    { text: 'Organization', filtertype: 'input', datafield: 'organization', width: '10%', cellclassname: '', },
                ]
            } else {
                columns = [
                    {
                        text: 'Actions',
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + View + '" class="row_edit" /></div>';
                        },
                        width: '4%', filterable: false,
                    },
                    {
                        text: 'Record Id', width: '8%', cellclassname: '', filtertype: 'input', datafield: 'cargohub_id',

                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (data.shipment_details.cargohub_id) {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + data.shipment_details.cargohub_id + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: 'Invoice number', filtertype: 'input', datafield: 'invoice_id', width: '8%', cellclassname: '', },
                    {
                        text: 'MAWB', filtertype: 'input', datafield: 'master_airwaybill', width: '6%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (data.shipment_details.master_airwaybill) {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + data.shipment_details.master_airwaybill + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: 'Year', filtertype: 'input', datafield: 'year_invoice', width: '3%', cellclassname: '', },
                    { text: 'Period', filtertype: 'input', datafield: 'period', width: '5%', cellclassname: '', },
                    {
                        text: 'Customer', filtertype: 'input', datafield: 'awb_shp_name', width: '9%', cellclassname: '',
                        cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                            let emailIcon = '';
                            let value1 = rowdata?.shipment_details?.customer?.awb_shp_name
                            if (!rowdata?.shipment_details?.customer?.email || rowdata?.shipment_details?.customer?.email === 0) {
                                emailIcon = '<img src="' + EmailRed + '" class="row_email row_email_red" />';
                            } else {
                                emailIcon = '<img src="' + EmailGreen + '" class="row_email row_email_green" />';
                            }
                            return value1 ? '<div class="jqx-grid-cell-left-align" style="margin-top: 10px;">' + (activeTab !== 'Archived' ? emailIcon : '') + ' ' + value1 + '</div>' : '';
                        }
                    },
                    {
                        text: 'Invoice date',filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'created_at', width: '5%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split('T')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: 'Expiration date',filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'expiry_date', width: '7%', cellclassname: '', },
                    // {
                    //     text: 'Account Number', filtertype: 'textbox', width: '7%', cellclassname: '',
                    //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                    //         let customer = data.shipment_details.customer;
                    //         if (customer) {
                    //             return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + (customer.awb_shp_acc_no ?? '') + "</div>";
                    //         } else {
                    //             return '';
                    //         }
                    //     },
                    // },
                    // {
                    //     text: 'VIT Code', width: '5%', filtertype: 'textbox', cellclassname: '',
                    //     cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                    //         const vatCode = Number(data.items?.[0]?.vat);
                    //         const btwCode = vatCode === 21 ? 1 : vatCode === 9 ? 2 : vatCode === 0 ? 3 : ""
                    //         return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${btwCode ?? ''}</div>`;
                    //     },
                    // },
                    {
                        text: 'Vat Code', width: '4%',datafield: 'vat_code', filterable : false, cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            const vatCode = data.items && data.items.length > 0 ? data.items[0].vat : '';
                            return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${vatCode ?? ''}${vatCode ? '%' : ''}</div>`;
                        },
                    },
                    {
                        text: 'Vat Amount',datafield: 'vat', width: '5%', filtertype: 'input', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            // const vatAmount = data.items && data.items.length > 0 ? data.items[0].amount : '';
                            return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${cellValue ?? ''}</div>`;
                        },
                    },
                    { text: 'Currency', filtertype: 'input', datafield: 'currency', width: '4%', cellclassname: '', },
                    {
                        text: 'Consolidate', filtertype: 'checkedlist', datafield: 'consolidated_id', width: '5%', cellclassname: '',
                        filteritems: [
                            { label: "Yes", value: "Yes" },
                            { label: 'No', value: "No" },
                        ],
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + "Yes" + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: 'Amount Excl', filtertype: 'input', datafield: 'subtotal', width: '6%', cellclassname: '', },
                    {
                        text: 'Download', filtertype: 'range', filtermode: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'download_date', width: '5%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split(' ')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    {
                        text: 'Dld Status', width: '4%', cellclassname: '',filtertype: 'checkedlist', datafield: 'download_status',
                        filteritems: [
                            { label: "Yes", value: "Yes" },
                            { label: 'No', value: "No" },

                        ],
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue == 1) {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + "Yes" + "</div>";
                            } else {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + "No" + "</div>";;
                            }
                        },
                    },
                    {
                        text: "Mail Send", datafield: "send_status", filtertype: 'checkedlist', width: "4%", cellclassname: '',
                        filteritems: [
                            { label: "Yes", value: "Yes" },
                            { label: 'No', value: "No" },

                        ],
                        cellsrenderer: function (rowIndex, dataField, cellValue, defaultHtml, column, rowData) {
                            const rowId = rowData?.id || rowData?.bounddata?.id || "";
                            if (cellValue == 1) {
                                return `
                                <div style="margin-top:13px;margin-left:10px; cursor: pointer;"class="mail-send-cell"data-row-id="${rowId}">
                                <img src="${greencheck}" alt="sent" style="width:16px; height:16px;" />
                                </div>
                            `;
                            }
                            return "";
                        }
                    },
                    {
                        text: 'Send Date',filtertype: 'range', filtermode: 'range', datafield: 'send_date', width: '6%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split(' ')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    //    { text: 'Downloaded', filtertype: 'textbox', datafield: 'download_status', width: '5%',
                    //        cellsrenderer: (row, columnfield, value) => {
                    //            if (value == 1) {
                    //                return `
                    //                    <div class="jqx-grid-cell-left-align" style="margin-top:13px; color: green !important;">
                    //                        Yes
                    //                    </div>
                    //                `;
                    //            } else {
                    //                return `
                    //                    <div class="jqx-grid-cell-left-align" style="margin-top:13px;"></div>
                    //                `;
                    //            }
                    //        }
                    //    },
                ];
            }
            // Define nested columns for connected records
            let nestedColumns = []
            if (activeTab != 'Consolidate') {
                nestedColumns = [
                    { text: "Quantity", filtertype: "number", datafield: "qty", width: "7%", cellclassname: "" },
                    {
                        text: "Created At", datafield: "created_at", width: "10%", cellclassname: "",
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split('T')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    {
                        text: "Updated At", datafield: "updated_at", width: "10%", cellclassname: "",
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split('T')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: "Category", filtertype: "number", datafield: "category_name", width: "15%", cellclassname: "" },
                    { text: "Amount excl", filtertype: "number", cellsformat: "d2", datafield: "amount", width: "8%", cellclassname: "" },
                    { text: "TTL amount excl", filtertype: "number", cellsformat: "d2", datafield: "ex_total", width: "8%", cellclassname: "" },
                    {
                        text: "VAT", filtertype: "number", datafield: "vat", width: "5%", cellclassname: "",
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${cellValue ?? ''}${cellValue ? '%' : ''}</div>`;
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: "TTL amount", filtertype: "number", cellsformat: "d2", datafield: "total", width: "8%", cellclassname: "" },
                ];
            }
            else {
                nestedColumns = [
                    {
                        text: 'Record Id', filtertype: 'input', width: '8%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (data.shipment_details.cargohub_id) {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + data.shipment_details.cargohub_id + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: 'Invoice number', filtertype: 'input', datafield: 'invoice_id', width: '8%', cellclassname: '', },
                    {
                        text: 'MAWB', filtertype: 'input', width: '8%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (data.shipment_details.master_airwaybill) {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + data.shipment_details.master_airwaybill + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: 'Year', filtertype: 'input', datafield: 'year_invoice', width: '3%', cellclassname: '', },
                    { text: 'Period', filtertype: 'input', datafield: 'period', width: '5%', cellclassname: '', },
                    {
                        text: 'Invoice date', filtertype: 'input', datafield: 'created_at', width: '5%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split('T')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: 'Expiration date', filtertype: 'input', datafield: 'expiry_date', width: '7%', cellclassname: '', },
                    {
                        text: 'Account Number', filtertype: 'input', width: '7%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            let customer = data.shipment_details.customer;
                            if (customer) {
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + (customer.awb_shp_acc_no ?? '') + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    {
                        text: 'VIT Code', width: '5%', filtertype: 'input', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            const vatCode = Number(data.items?.[0]?.vat);
                            const btwCode = vatCode === 21 ? 1 : vatCode === 9 ? 2 : vatCode === 0 ? 3 : ""
                            return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${btwCode ?? ''}</div>`;
                        },
                    },
                    {
                        text: 'Vat Code', width: '5%', filtertype: 'input', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            const vatCode = data.items && data.items.length > 0 ? data.items[0].vat : '';
                            return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${vatCode ?? ''}${vatCode ? '%' : ''}</div>`;
                        },
                    },
                    {
                        text: 'Vat Amount', width: '6%', filtertype: 'input', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            const vatAmount = data.items && data.items.length > 0 ? data.items[0].amount : '';
                            return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${vatAmount ?? ''}</div>`;
                        },
                    },
                    { text: 'Currency', filtertype: 'input', datafield: 'currency', width: '5%', cellclassname: '', },
                    { text: 'Amount Excl', filtertype: 'input', datafield: 'total', width: '6%', cellclassname: '', },
                    {
                        text: 'Download Date', datafield: 'download_date', width: '6%', cellclassname: '',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split(' ')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                ]
            }
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const id = record.uid.toString();
                let items
                activeTab != 'Consolidate' ? items = dataAdapter.loadedData.Rows[id].items || [] : items = dataAdapter.loadedData.Rows[id].invoices;
                const nestedGridContainer = parentElement.children[0];
                parentElement.addEventListener("click", (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass("jqx-icon-arrow-right")) {
                        event.stopPropagation();
                    }
                });
                const nestedSource = {
                    datatype: "json",
                    id: "itemsChildID",
                    datafields: [
                        { name: "id", type: "number" },
                        { name: "amount", type: "string" },
                        { name: "created_at", type: "string" },
                        { name: "invoice_category_setting_id", type: "number" },
                        { name: "category_name", type: "number" },
                        { name: "qty", type: "number" },
                        { name: "shipment_invoice_id", type: "number" },
                        { name: "status", type: "number" },
                        { name: "total", type: "string" },
                        { name: "updated_at", type: "string" },
                        { name: "vat", type: "number" },
                        { name: "ex_total", type: "number" },

                        //  { name: 'id', type: 'string' },
                        { name: 'shipment_record_id', type: 'string' },
                        { name: 'invoice_id', type: 'string' },
                        { name: 'shipment_details', type: 'string' },
                        { name: 'items', type: 'string' },
                        { name: 'created_at', type: 'string' },
                        { name: 'total', type: 'string' },
                        { name: 'status', type: 'string' },
                        { name: 'condition', type: 'string' },
                        { name: 'condition_code', type: 'string' },
                        { name: 'destination', type: 'string' },
                        { name: 'scm', type: 'string' },
                        { name: 'scm_date', type: 'date' },
                        { name: 'asset_type', type: 'string' },
                        { name: 'handler_name', type: 'string' },
                        { name: 'repair_name', type: 'string' },
                        { name: 'record_id', type: 'string' },
                        { name: 'invoice_id', type: 'string' },
                        { name: 'year_invoice', type: 'string' },
                        { name: 'period', type: 'string' },
                        { name: 'expiry_date', type: 'string' },
                        { name: 'account_number', type: 'string' },
                        { name: 'vat_code', type: 'string' },
                        { name: 'vat_amount', type: 'string' },
                        { name: 'download_status', type: 'string' },
                        { name: 'currency', type: 'string' },
                        { name: 'master_airwaybill', type: 'string' },
                        { name: 'download_date', type: 'string' },
                        { name: 'customer_id', type: 'string' },
                        { name: 'email', type: 'string' },
                    ],
                    localdata: items,
                };

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedItemColumns = [
                    { text: "Quantity", filtertype: "number", datafield: "qty", width: "7%", cellclassname: "" },
                    {
                        text: "Created At", datafield: "created_at", width: "10%", cellclassname: "",
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split('T')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    {
                        text: "Updated At", datafield: "updated_at", width: "10%", cellclassname: "",
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                const formatedDate = cellValue?.split('T')[0]
                                return "<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>" + formatedDate + "</div>";
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: "Category", filtertype: "number", datafield: "category_name", width: "8%", cellclassname: "" },
                    { text: "Amount excl", filtertype: "number", cellsformat: "d2", datafield: "amount", width: "8%", cellclassname: "" },
                    { text: "TTL amount excl", filtertype: "number", cellsformat: "d2", datafield: "ex_total", width: "8%", cellclassname: "" },
                    {
                        text: "VAT", filtertype: "number", datafield: "vat", width: "5%", cellclassname: "",
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue) {
                                return `<div class='jqx-grid-cell-left-align' style='margin-top: 12px; margin-left:5px'>${cellValue ?? ''}${cellValue ? '%' : ''}</div>`;
                            } else {
                                return '';
                            }
                        },
                    },
                    { text: "TTL amount", filtertype: "number", cellsformat: "d2", datafield: "total", width: "8%", cellclassname: "" },
                ];

                const inititemdetails = (index, parentElement, gridElement, record) => {
                    const id = record.uid.toString();

                    const nestedGridContainer = parentElement.children[0];

                    let orderssecond = nestedDataAdapter.loadedData[id].items;
                    const itemSource = {
                        datatype: 'json',
                        datafields: [
                            { name: "id", type: "number" },
                            { name: "qty", type: "number" },
                            { name: "created_at", type: "string" },
                            { name: "updated_at", type: "string" },
                            { name: "category_name", type: "number" },
                            { name: "amount", type: "string" },
                            { name: "total", type: "string" },
                            { name: "vat", type: "number" },

                            { name: "invoice_category_setting_id", type: "number" },
                            { name: "shipment_invoice_id", type: "number" },
                            { name: "ex_total", type: "number" },
                            { name: "status", type: "number" },
                        ],
                        localdata: orderssecond,
                    }

                    const nestedhawbDataAdapter = new window.$.jqx.dataAdapter(itemSource);

                    const nestedGridOptions = {
                        width: '100%',
                        pageable: false,
                        sortable: false,
                        autoheight: true,
                        source: nestedhawbDataAdapter,
                        filterable: false,
                        columns: nestedItemColumns,
                        rowsheight: 42,
                    };
                    window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
                };

                const nestedGridOptions = {
                    width: "100%",
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: 10 * 45,
                    selectionmode: "", // checkbox
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: false,
                    rowsheight: 45,
                    showemptyrow: false,
                    rowdetails: activeTab == "Consolidate",
                    initrowdetails: activeTab == "Consolidate" ? inititemdetails : '',
                    rowdetailstemplate: {
                        rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                        rowdetailsheight: 10 * 45,
                        rowdetailshidden: true,
                    },
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid("getrows");
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window
                                .$(nestedGridContainer)
                                .jqxGrid("setcellvalue", row.uid, "uid", rowid);
                            window.$(nestedGridContainer).jqxGrid("updaterow", rowid, row);
                            window
                                .$(nestedGridContainer)
                                .find(`[role="row"][row-id="${row.uid}"]`)
                                .attr("row-id", rowid);
                        }
                    },
                };

                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };

            const gridOptions = {
                width: "100%",
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: "checkbox",
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ["50", "100", "200", "500", "1000"],
                pagerButtonsCount: 5,
                pagerMode: "advanced",
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rowdetails: activeTab !== "Open",
                initrowdetails: initrowdetails,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: 10 * 45,
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                //    ready: function () {
                //      localStorgeFilter();
                //    },
            };


            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);
                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        const innerData = rowData.shipment_record_id;
                        localStorage.removeItem('SHEdit');
                        // loadDetails(rowData.id);
                        localStorage.setItem('SHEdit', JSON.stringify(innerData));
                        localStorage.setItem('ccbackUrl', '/ForwarderShipments/Invoice');
                        localStorage.setItem('AddShipmentType', 'import');
                        history.push('/ForwarderShipments/AddShipmentRecords');
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
            });
            window.$(gridRefs[activeTab].current).on('click', '.row_email', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                const customerId = rowData?.customer_details?.id || rowData?.customer_id;

                let email = '';
                let invIds = [];
                if (activeTab === 'Consolidate') {
                    invIds = rowData.invoices.map(ids => ids.id)
                    email = rowData?.customer_email;
                } else {
                    email = rowData?.shipment_details?.customer?.email;
                }
                setEmailMeta({ id: rowData?.id, invoice_ids: invIds });
                setEmailData({ email });
                if(email) setShowEmailModal(true); else toast.error("Email doesnt exist for this customer, can't send email")});

            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
            //     const email = rowData?.customer_email;
            //     const id = rowData?.id;

            //     try {
            //         let url = 'invoice/customer-mail-all';
            //         const payload = { id: id, email: email, type: 'download' };

            //         const res = await withRFSToken.post(url, payload, {
            //             responseType: 'blob',
            //         });

            //         const now = new Date();
            //         const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
            //         const blob = new Blob([res.data], { type: res.headers['content-type'] });
            //         const blobUrl = window.URL.createObjectURL(blob);
            //         const a = document.createElement('a');
            //         a.href = blobUrl;
            //         a.download = formattedDateTime + ' Downloaded.pdf';
            //         document.body.appendChild(a);
            //         a.click();
            //         a.remove();
            //         window.URL.revokeObjectURL(blobUrl);
            //         toast.success('PDF Download started');

            //     } catch (error) {
            //         console.error('Error saving email:', error);
            //     }
            // });
            window.$(gridRefs[activeTab].current).on('click','.pdf_click_action', async function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                const email = rowData?.customer_email;
                const invoice_ids = rowData?.invoices?.map(item => item.id);
                let url = 'invoice/customer-mail-all';
                const payload = { invoice_ids, email, type: 'download' };
                withRFSToken.post(url, payload, {  headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                } ,responseType: 'blob' }).then(function (res) {                   
                    const now = new Date();
                    const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
                    const blob = new Blob([res.data], {
                        type: res.headers['content-type'],
                    });
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = blobUrl;
                    a.download = `${formattedDateTime} Downloaded.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(blobUrl);
                    if(res?.data?.response_msg)
                     toast.error(res?.data?.response_msg);
                    else
                     toast.success("Downloaded")
                })
                .catch(function (error) {
                    console.error('Error downloading PDF:', error);
                    toast.error('Something went wrong while downloading PDF');
                });
            }
            );
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    if (activeTab == 'Consolidate') {
                        const invoices = selectedRow.invoices || [];
                        invoices.forEach((inv) => {
                            if (!checkUlds.includes(inv.id)) {
                                checkUlds.push(inv.id);
                            }
                        });
                        setGridSelect(prevGridSelect => {
                            const newInvoices = invoices.filter(inv => !prevGridSelect.some(row => row.id === inv.id));
                            return [...prevGridSelect, ...newInvoices];
                        });
                    } else {
                        const uldNumber = selectedRow.id;
                        const selectedRowId = selectedRow.uid;
                        if (!checkUlds.includes(uldNumber)) {
                            checkUlds.push(uldNumber);
                        }
                        setGridSelect(prevGridSelect => {
                            if (!prevGridSelect.some(row => row.id === uldNumber)) {
                                return [...prevGridSelect, selectedRow];
                            }
                            return prevGridSelect;
                        });
                    }
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        if (activeTab === 'Consolidate') {
                            const allInvoices = [];
                            allIds.forEach(row => {
                                if (row.invoices && Array.isArray(row.invoices)) {
                                    allInvoices.push(...row.invoices);
                                }
                            });
                            setGridSelect(allInvoices);
                        } else {
                            setGridSelect(allIds);
                        }
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    if (activeTab === 'Consolidate') {
                        const invoices = event.args.row.invoices || [];
                        const invoiceIds = invoices.map(inv => inv.id);
                        checkUlds = checkUlds.filter(id => !invoiceIds.includes(id));
                        setGridSelect(prevSelection => prevSelection.filter(row => !invoiceIds.includes(row.id)));
                    } else {
                        const unselectedRowId = event.args.row.id;
                        setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                        if (!checkUlds.includes(unselectedRowId)) {
                            checkUlds.push(unselectedRowId);
                        } else {
                            checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                        }
                    }
                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                }
            });
        }
    }, [gridData]);

    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
    };

    const handleDownload = async () => {
        if (gridSelect.length) {
            const selectId = gridSelect.map(ids => ids.id)

            try {
                const res = await withRFSToken.post('invoice/export-list', { invoice_ids: selectId },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        },
                        responseType: 'blob',
                    }).then(function (res) {
                        const now = new Date();
                        const formattedDateTime = `${String(now.getDate()).padStart(2, '0')}-${String(now.getMonth() + 1).padStart(2, '0')}-${now.getFullYear()} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

                        const blob = new Blob([res.data], { type: res.headers['content-type'] });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = formattedDateTime + ' Downloaded';
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
                        }, 1);
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            toast.error('Please select Invoices to download');
        }
    }
    const handleEmailModalClose = () => {
        setShowEmailModal(false);
        setEmailData({ email: '' });
        setEmailMeta({});
    };

    const handleEmailChange = (e) => {
        const { name, value } = e.target;
        setEmailData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const handleMoveToArchive = async () => {
        if (gridSelect.length) {
            const hasMissingDownloadDate = gridSelect.some(item => item.download_date == null || item.download_date === "");
            if (hasMissingDownloadDate) { toast.error("Unable to archive — some items are still pending download."); return; }
            const selectId = gridSelect.map(item => item.id);
            try {
                const res = await withRFSToken.post("invoice/remove", { ids: selectId, is_deleted: activeTab == 'Active' ? 0 : 1, action_from: "grid" })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        if (res.data.response_code == 200) {
                            toast.success(res.data.response_msg || "Invoice moved successfully");
                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                            });
                            setGridSelect([]);
                            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
                        }
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        else {
            toast.error('Please select invoices to move to archive');
        }

    };
    const handleMoveToConsolidate = async () => {
        if (gridSelect.length) {
            const isConsildate = gridSelect.some(item => item.send_status == 1);
            if (isConsildate) { toast.error("Unable to Consildate — some items mails already sent."); return; }
            const selectId = gridSelect.map(item => item.id);
            try {
                const res = await withRFSToken.post("invoice/make-consolidate", { invoice_ids: selectId })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        if (res.data.response_code == 200) {
                            toast.success(res.data.response_msg || "Invoice moved successfully");
                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                            });
                            setGridSelect([]);
                            window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata");
                        } else {
                            toast.error(res.data.response_msg)
                        }
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        else {
            toast.error('Please select invoices to consolidate');
        }

    };

    const openConfirmModal = () => setShowConfirmModal(true);
    const closeConfirmModal = () => setShowConfirmModal(false);

    const confirmArchive = () => {
        closeConfirmModal();
        handleMoveToArchive();
    };
    const handleEmailSave = async () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const email = emailData?.email?.trim();
        if (!email || !emailRegex.test(email)) {
            toast.error('Please enter a valid email address');
            return;
        }
        try {
            setIsEmailSaving(true);
            let url = 'customer-email-save';
            if (activeTab === 'Consolidate') {
                url = 'invoice/customer-mail-all';
            }
            const res = await withRFSToken.post(url, { ...emailMeta, email, type: 'mail' });
            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.response_msg);
            } else {
                toast.error(res?.data?.response_msg || 'Failed to save email');
            }
            setShowEmailModal(false);
            setTimeout(() => {
                window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata');
            }, 1);
        } catch (error) {
            console.error('Error saving email:', error);
            toast.error('Failed to save email');
        } finally {
            setIsEmailSaving(false);
        }
    };

    return (
        <div className="">
            {showConfirmModal && (
                <ConfModal
                    header="Confirm Action"
                    subHeader={`Are you sure you want to ${activeTab === "Active" ? "move selected invoices to Archive" : "restore invoices to Active"}?`}
                    modalConf={confirmArchive}
                    closeModal={closeConfirmModal}
                    primaryBtn="Yes, Proceed"
                    secondaryBtn="Cancel"
                />
            )}
            <Header page_type='fsm' logo_url='/ForwarderShipments/ShipmentRecords' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <TopMenu module='FSHPMNGR' />
                        <div className="">
                            <div className="allcontent-fl">
                                <div className="lcontent">
                                    <div className="mb-3 nestedtabs rounded minh">
                                        <div className='d-flex'>
                                            {(activeTab == "Active" || activeTab == "Archived") && (
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                                        <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {activeTab == "Active" && <Dropdown.Item onClick={() => handleMoveToConsolidate()}>Move to Consolidated</Dropdown.Item>}
                                                        <Dropdown.Item onClick={() => openConfirmModal()}>{activeTab == 'Active' ? "Move to Archive" : "Move to Active"}</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>)}
                                            <span className="selected mt-1">
                                                Selected Invoice <Badge>{gridSelect.length}</Badge>
                                            </span>
                                            <div className='ulddown'>
                                                <button onClick={handleDownload} ><img src={Export} />Download</button>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="maindiv">
                                        <div className='trashdonload position-relative'>
                                            <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                                                <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                                                    {!isLoading && <>
                                                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                        <div ref={gridRefs.Active} className='bookinggrid' ></div>
                                                    </>
                                                    }
                                                </Tab>
                                                <Tab eventKey="Consolidate" title={<span>Consolidated</span>} className='moveto'>
                                                    {!isLoading && <>
                                                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                        <div ref={gridRefs.Consolidate} className='bookinggrid' ></div>
                                                    </>
                                                    }
                                                </Tab>
                                                <Tab eventKey="Archived" title={<span>Archived</span>} className='moveto'>
                                                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                    {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                                                </Tab>
                                            </Tabs>
                                        </div>
                                        {selectedRowData && (
                                            <div className='SecondDiv'>

                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showEmailModal} onHide={handleEmailModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-2" controlId="invoiceEmailInput">
                        <Form.Control
                            name='email'
                            placeholder='Add Email Address'
                            onChange={handleEmailChange}
                            value={emailData?.email}
                            disabled={true}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={handleEmailModalClose}> Cancel </Button>
                        <Button variant="primary" onClick={handleEmailSave} disabled={isEmailSaving}> Send Email </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Invoice